import { useEffect, useState } from "react";
import { examSessions, examSessions1 } from "../../_helpers/exams";
import classNames from "classnames";

export const ExamsTimeTable = () => {

    const [srcWrd, setSrcWrd] = useState('');
    const [allNames, setAllnames] = useState([]);

    

   useEffect(() => {

    const invArray = examSessions.map((session) => {
        return session.invigilators;
    });

    const emptyArr = []

   for (let k = 0;k<invArray.length;k++) {
     invArray[k].forEach((elem) => {
        emptyArr.push(elem);
     })
   }

   setAllnames(emptyArr);


    const namesStats = emptyArr.map((nm) => {
        const repNum = emptyArr.filter((val) => val === nm).length;
        return {name: nm, sessions: repNum };
    })

    console.log(namesStats);
   
   },[]);



    

    return (
        <div className="page-body">
           
            <div className="levels-label">
                <div className="levels-cap">ORDINARY LEVEL</div>
                <div className="levels-cap">ADVANCED LEVEL</div>
            </div>
            <div className="levels">
                <div className="level-cont">
                <div className="session-container">
                    <strong>MORNING</strong>
                </div>
                <div className="session-container">
                    <strong>AFTERNOON</strong>
                </div>
                    {examSessions.map((data) => {

                        return (
                            
                                <div className="session-container">
                                    <div className="date-label">
                                        <label className="cap">Date:</label>
                                        <label className="val">{data.date}</label>
                                    </div>
                                    <div className="room-label">
                                        <label className="cap">Rooms:</label>
                                        <label className="val">{data.halls}</label>
                                    </div>
                                    <div className="room-label">
                                        <label className="cap">invigilators:</label>
                                        <div className="inv-box">
                                            {data.invigilators.map((inv) => (
                                                <span 
                                                    className={classNames(
                                                        "invi-name",
                                                        {'res': srcWrd?.toLowerCase() === inv.toLocaleLowerCase()}
                                                    )}
                                                >
                                                    {inv}
                                                </span>
                                            ))}
                                        </div>
                                    </div>
                                    
                                </div>
                        )
                    })}
                </div>
                <div className="level-cont">
                    <div className="session-container">
                        <strong>MORNING</strong>
                    </div>
                    <div className="session-container">
                        <strong>AFTERNOON</strong>
                    </div>
                    {examSessions1.map((data) => {

                        return (
                            
                                <div className="session-container">
                                    <div className="date-label">
                                        <label className="cap">Date:</label>
                                        <label className="val">{data.date}</label>
                                    </div>
                                    <div className="room-label">
                                        <label className="cap">Rooms:</label>
                                        <label className="val">{data.halls}</label>
                                    </div>
                                    <div className="room-label">
                                        <label className="cap">invigilators:</label>
                                        <div className="inv-box">
                                            {data.invigilators.map((inv) => (
                                                <span 
                                                    className={classNames(
                                                        "invi-name",
                                                        {'res': srcWrd.toLowerCase() === inv.toLocaleLowerCase()}
                                                    )}
                                                >
                                                    {inv}
                                                </span>
                                            ))}
                                        </div>
                                    </div>
                                    
                                </div>
                        )
                    })}
                </div>
            </div>
        </div>
    )
}